import { render, staticRenderFns } from "./AutomacaoPaleta.vue?vue&type=template&id=671bcb9c"
import script from "./AutomacaoPaleta.vue?vue&type=script&lang=js"
export * from "./AutomacaoPaleta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports